import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Input, FormBtn, OtherFormBtn } from '../components/form.jsx';
import { useUser } from '../UserContext.js';
import { auth, db } from '../auth.js';
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

const SignInPage = () => {
    const user = useUser();
    const [emailValid, setEmailValid] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);
    const [className, setClassName] = useState('form-btn');
    const [errMsg, setErrMsg] = useState('');
    const [display, setDisplay] = useState('none');
    const provider = new GoogleAuthProvider();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/projects', { replace: true });
        }
    }, [user, navigate]);

    const handleGoogleLogin = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                const setData = async () => {
                    const docSnap = await getDoc(doc(db, "user", result.user.uid));
                    if (!docSnap.exists()) {
                        await setDoc(doc(db, "user", result.user.uid), {
                            name: result.user.displayName,
                            projectNum: 0
                        }, { merge: true });
                    }
                }
                setData()
                    .then(() => {
                        navigate('/projects', { replace: true });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }).catch((error) => {
                const errorMsg = error.code.split('/')[1].replaceAll('-', ' ');
                setDisplay('flex');
                setErrMsg(errorMsg);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setClassName('form-btn-disabled');
        const emailVal = e.target[0].value;
        const passwordVal = e.target[1].value;
        signInWithEmailAndPassword(auth, emailVal, passwordVal)
            .then(() => {
                navigate('/projects', { replace: true });
            }).catch((error) => {
                const errorMsg = error.code.split('/')[1].replaceAll('-', ' ');
                setDisplay('flex');
                setErrMsg(errorMsg);
            });
    }
    function handleEmailChange(e) {
        setDisplay('none');
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(e.target.value)) {
            setEmailValid(false);
            setClassName('form-btn-disabled');
        } else {
            setEmailValid(true);
            if (passwordValid)
                setClassName('form-btn');
        }
    }
    function handlePasswordChange(e) {
        setDisplay('none');
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+]{8,}$/;
        if (!passwordRegex.test(e.target.value)) {
            setPasswordValid(false);
            setClassName('form-btn-disabled');
        } else {
            setPasswordValid(true);
            if (emailValid)
                setClassName('form-btn');
        }
    }
    return (
        <div className="container">
            <div className="sign-form">
                <div>
                    <h1>Login</h1>
                    <p>/</p>
                    <Link to="/signup" className='form-link'>
                        Register
                    </Link>
                </div>
                <p style={{ display }}>
                    <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {errMsg}
                </p>
                <form onSubmit={handleSubmit}>
                    <Input type='email' email={emailValid} handleChange={handleEmailChange} value='test@gmail.com' />
                    <Input type='password' password={passwordValid} handleChange={handlePasswordChange} value='test12345' />
                    <div className='form-link-pw'>
                        <Link to="/signup">
                            Forgot password?
                        </Link>
                    </div>
                    <FormBtn value='LOG IN' class={className} />
                    <OtherFormBtn action='In' value='Google' handleClick={handleGoogleLogin} />
                </form>
            </div>
        </div>
    )
}

export default SignInPage;
